//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { splitMentionedItemsCombiner } from '@galleries/selectors/splitMentionedItemsCombiner';
import { IDefaultInstagramAccount } from '@instagram-account/redux/account/instagramAccountModel';
import { ICuralateStore } from '@models/AppState';
import { IConnectedBrandInstagramBusinessAccounts } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import { getHasMultiHandleInstagramEnabled } from '@account-settings/redux/facebook-instagram/selectors/getMultiHandleFeature';
import { getIsTikTokMentionedRightsEnabled } from '@uia/rights/selectors/getUIARights';
import { getTikTokAccountSettings } from '@tiktok/redux/account/selectors/getTikTokAccountSettings';
import { getTikTokUser } from '@tiktok/redux/user/selectors/getTikTokUser';

export const getNonMentionedItems = createSelector(
  (state: ICuralateStore) =>
    state.galleries.requestRightsNonMentionedModal.materializedItems,
  (state: ICuralateStore) => state.instagram.account.defaultInstagramAccount,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.connectedInstagramAccounts,
  (state: ICuralateStore) => getHasMultiHandleInstagramEnabled(state),
  (state: ICuralateStore) => getIsTikTokMentionedRightsEnabled(state),
  (state: ICuralateStore) => getTikTokAccountSettings(state),
  (state: ICuralateStore) => getTikTokUser(state),
  (
    materializedItems: IContentLibraryItem[],
    defaultInstagramAccount: IDefaultInstagramAccount | undefined,
    connectedInstagramAccounts:
      | IConnectedBrandInstagramBusinessAccounts[]
      | undefined,
    isMultiHandleFeatureEnabled: boolean,
    isTikTokMentionedRightsEnabled: boolean,
    tikTokAccountData: ReturnType<typeof getTikTokAccountSettings>,
    tikTokUser: ReturnType<typeof getTikTokUser>,
  ) => {
    const { nonAtMentionedItems } = splitMentionedItemsCombiner(
      materializedItems,
      defaultInstagramAccount,
      connectedInstagramAccounts,
      isMultiHandleFeatureEnabled,
      isTikTokMentionedRightsEnabled,
      tikTokAccountData,
      tikTokUser,
    );
    return nonAtMentionedItems;
  },
);
